module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "1100px",
      "margin": "auto",
      "white-space": "pre",
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticClass: "preview-select",
    domProps: {
      "innerHTML": _vm._s(_vm.data)
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-header"
  }, [_c('nav', {
    staticClass: "preview-header-wrapper preview-navbar preview-navbar-default preview-navbar-fixed-top"
  }, [_c('div', {
    staticClass: "preview-header-content container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 logo"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/logo.png",
      "alt": "hellokid"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47cc1482","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/course/LessonPreview.vue
// module id = 1778
// module chunks = 8